import { IncError } from "@core/domain/errors/inc.error";
import i18n from "@i18n";

export class MaterialMapperError extends IncError {
    constructor() {
        super(i18n.t("error:entity.material.materialMapperError"));

        Object.setPrototypeOf(this, MaterialMapperError.prototype);
    }
}